const dict = {
  it: {
    custom: {
      email: {
        required: 'Il campo email è obbligatorio.',
        email: 'Il campo email deve contenere una email valida.'
      },
      name: {
        required: 'Il campo nome è obbligatorio.'
      },
      surname: {
        required: 'Il campo cognome è obbligatorio.'
      },
      telephone: {
        required: 'Il campo telefono è obbligatorio.'
      },
      city: {
        required: 'Il campo città è obbligatorio.'
      },
      company: {
        required: 'Il campo azienda è obbligatorio.'
      },
      province: {
        required: 'Il campo provincia è obbligatorio.'
      },
      career: {
        required: 'Il campo posizione è obbligatorio.'
      },
      curriculum: {
        required: 'Allegare il propio CV alla richiesta è obbligatorio.'
      },
      message: {
        required: 'Il campo messaggio è obbligatorio.'
      },
      privacy: {
        required: 'Devi aver letto e accettato le condizioni sulla tutela della privacy.'
      }
    }
  }
}

export default dict
